import { useContext } from 'react';
import PageData from '../PageData';
import { useLayout } from '../UISettingsProvider';
import AgendaStreamingContextProvider from '../common/AgendaStreamingContextProvider';
import FavoritesContextProvider from '../common/FavoritesContextProvider';
import LiveSection from '../live/common/LiveSection';
// import Highlights from './Highlights';
import LandingCarousel from './LandingCarousel';
import TopMatches from './TopMatches';
import Upcoming from './Upcoming';

import './style.css';
import LiveContext from '../contexts/LiveContext';
import { getConfiguration } from '../data/utils';
import { useFetchSeoSettings } from '../data/fetchSeoSettings';
import { SeoContext } from '../data/seo/SeoContextProvider';
import { useHandleSeoSettings } from '../data/seo/seoUtils';
import MainContext from '../contexts/MainContext';

export default function Landing(props) {
    const liveContext = useContext(LiveContext);
    const layout = useLayout();
    const conf = getConfiguration();
    const mainContext = useContext(MainContext);
    const cfgSeo = conf.seo;
    const seoContext = useContext(SeoContext);
    const [seoSettingsState] = useFetchSeoSettings(seoContext.pathname, false, cfgSeo && mainContext.currentSection.current === 'top-match' && !props.openFromPath);

    useHandleSeoSettings(seoSettingsState);

    function openMatch(sport, country, tournament, match) {
        liveContext.setMatchData({
            sportId: sport,
            countryId: country,
            tournamentId: tournament,
            matchId: match
        }, true);
        window.openSection('live-match');
    }

    return (
        <div className={"griglia-centrale-sport col stringimento-sidebar " + layout.order.divCentrale} id="div-centrale">
            <div className="contenitore-schedine-sport">
                <div id="xs-landing-2">
                    <div id="primo-blocco-sport" className="sport-blocco primo-blocco-sport go-up-arrow-on-overflow no-margin tablesExpanded">
                        <div className="competizione-sport" id="competizione-1">
                            <div className="l_1">
                                <div className="l_1_1">
                                    <PageData>
                                        <LandingCarousel />
                                    </PageData>
                                </div>
                                <div className="l_1_1">
                                    <div className="l_1_1_1">{'Live betting'}</div>
                                    <FavoritesContextProvider>
                                        <AgendaStreamingContextProvider>
                                            <LiveSection openMatch={openMatch}
                                                         isLiveSuite={false}
                                                         moreBetsEnabled={false} />
                                        </AgendaStreamingContextProvider>
                                    </FavoritesContextProvider>
                                </div>
                                {/* <div className="l_1_1">
                                    <div className="l_1_1_1">{'Highlights'}</div>
                                    <Highlights />
                                </div> */}
                                <div className="l_1_1">
                                    <div className="l_1_1_1">{'Highlights'}</div>
                                    <TopMatches />
                                </div>
                                <div className="l_1_1">
                                    <div className="l_1_1_1">{'Upcoming'}</div>
                                    <Upcoming />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}